import { Pipe, PipeTransform } from "@angular/core";
import { ICodes, IObservationDefinition } from "@comunicare/comunicare-interfaces";

@Pipe({
  name: "findObsDefByLoinc",
})
export class FindObsDefByLoincPipe implements PipeTransform {
  transform(observationDefinition: IObservationDefinition[], code: ICodes): IObservationDefinition {
    return observationDefinition.find((el) => el.loinc === code.coding[0]?.code);
  }
}
